// removed by extract-text-webpack-plugin
module.exports = {"header":"_3iQmbvaQ91ZO-XVrKMe5ye","left":"_1BIlUO2aVbdv9Js4Fia7xx","center":"_1DhFwEkruRlPOSn8tK1fAs","right":"_3_zXvhDTDFQvBVPyVqz0z9","close":"_2WG2-rCo0mNero9hW5qZ8P"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/header.css
// module id = 885
// module chunks = 0